// extracted by mini-css-extract-plugin
export default {"button":"ResetAllFilters_button__vWlym","tooltip":"ResetAllFilters_tooltip__x5OSe"};